import React, { useEffect, useMemo, useState } from "react";

export default function SvgFloorPlan({
  svgUrl,
  selectedLotId,
  onLotSelect,
  filters,
}) {
  const [svgText, setSvgText] = useState("");

  useEffect(() => {
    let cancel = false;

    fetch(svgUrl)
      .then((r) => r.text())
      .then((txt) => {
        if (!cancel) setSvgText(txt);
      })
      .catch(() => {
        if (!cancel) setSvgText("");
      });

    return () => {
      cancel = true;
    };
  }, [svgUrl]);


useEffect(() => {
  const root = document.getElementById("svg-floorplan-root");
  if (!root) return;

  const lotes = root.querySelector("#lotes");
  const numeros = root.querySelector("#numeros");
  const letras = root.querySelector("#letras");
  const vias = root.querySelector("#vias");

  if (lotes) lotes.style.display = "block"; // siempre visible

  // ✅ Aquí decides cuándo mostrar números/letras
  if (numeros) numeros.style.display = filters?.showUtilities ? "block" : "none";
  if (letras) letras.style.display = "block";

  // ✅ Vías según filtro
  if (vias) vias.style.display = filters?.showRoads ? "block" : "none";
}, [filters]);


  // Click en lotes
  useEffect(() => {
    const root = document.getElementById("svg-floorplan-root");
    if (!root) return;

    const lotGroup = root.querySelector("#lotes");
    if (!lotGroup) return;

    const handler = (e) => {
      const path = e.target.closest("path[id^='lote-']");
      if (!path) return;

      const lotId = path.id; // "lote-101"
      onLotSelect?.({ id: lotId, lotNumber: lotId.replace("lote-", "") });
    };

    lotGroup.addEventListener("click", handler);
    return () => lotGroup.removeEventListener("click", handler);
  }, [onLotSelect]);

  return (
    <div className="w-full overflow-auto">
      <div
        id="svg-floorplan-root"
        className="w-full"
        // ⚠️ Asegúrate que este SVG lo generas tú (no lo suba cualquiera sin validar)
        dangerouslySetInnerHTML={{ __html: svgText }}
      />
    </div>
  );
}
